import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { contactPageData } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;

class Contact extends Component {
  render() {
    const theme = this.props.theme;
    const embedded = this.props.embedded;
    const Root = embedded ? "section" : "div";
    const Content = embedded ? "div" : "main";

    return (
      <Root
        id={embedded ? "contact" : undefined}
        className={`contact-main site-scroll-section${
          embedded ? " embedded-section" : ""
        }`}
      >
        {!embedded && <Header theme={theme} />}
        <Content className="basic-contact">
          <Fade bottom duration={1000} distance="40px">
            <div className="contact-content">
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                {ContactData.title}
              </h1>

              <section
                className="contact-card"
                style={{ backgroundColor: theme.highlight }}
              >
                <h2 style={{ color: theme.text }}>
                  {ContactData.sectionTitle}
                </h2>

                <div className="direct-contact">
                  <span style={{ color: theme.secondaryText }}>
                    {ContactData.directTitle}
                  </span>
                  <a
                    className="whatsapp-link"
                    href={ContactData.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span
                      className="iconify"
                      data-icon="fa-brands:whatsapp"
                      data-inline="false"
                      aria-hidden="true"
                    ></span>
                    {ContactData.whatsappText}
                  </a>
                </div>

                <div className="contact-details-grid">
                  <div className="contact-detail">
                    <span>{ContactData.phoneLabel}</span>
                    <a href={ContactData.phoneUrl} dir="ltr">
                      {ContactData.phone}
                    </a>
                  </div>
                  <div className="contact-detail">
                    <span>{ContactData.primaryEmailLabel}</span>
                    <a href={`mailto:${ContactData.primaryEmail}`} dir="ltr">
                      {ContactData.primaryEmail}
                    </a>
                  </div>
                  <div className="contact-detail">
                    <span>{ContactData.alternativeEmailLabel}</span>
                    <a
                      href={`mailto:${ContactData.alternativeEmail}`}
                      dir="ltr"
                    >
                      {ContactData.alternativeEmail}
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </Fade>
        </Content>
        {!embedded && (
          <>
            <Footer theme={theme} onToggle={this.props.onToggle} />
            <TopButton theme={theme} />
          </>
        )}
      </Root>
    );
  }
}

export default Contact;
